import { FC, useMemo, type JSX } from 'react';
import { useParams } from 'react-router-dom';

import CreateEditLineItemGroupControl from '@/ui/components/createEditLineItemGroupControl/CreateEditLineItemGroupControl';

import AuthenticatedPageWrapper from '@/ui/layouts/authenticatedPageWrapper/AuthenticatedPageWrapper';
import './NewEditItemGroupPage.sass';

const NewEditItemGroupPage: FC = (): JSX.Element => {
  const params: any = useParams();

  const lineItemGroupId = useMemo(() => params.lineItemGroupId, [params]);

  return (
    <AuthenticatedPageWrapper
      className="edit-item-group-page"
      breadcrumbItems={[
        { label: 'Back', to: '/items/groups' },
        { label: 'Item group' },
      ]}
    >
      <CreateEditLineItemGroupControl lineItemGroupId={lineItemGroupId} />
    </AuthenticatedPageWrapper>
  );
};

export default NewEditItemGroupPage;
